import type { TemplateCategoryApi } from './templates-api.types';

/** Fixed, org-independent list — there is no endpoint for it. Keep in canonical casing. */
export const TEMPLATE_CATEGORIES: TemplateCategoryApi[] = [
  'Announcement',
  'Newsletter',
  'Plain',
  'Event',
  'Lifecycle',
];

export type TemplateCategory = TemplateCategoryApi;

/** A template with its current body — from create/update/duplicate or a single-template load. */
export type Template = {
  itemId: string;
  name: string;
  description: string | null;
  category: TemplateCategory | null;
  thumbnailUrl: string | null;
  contentId: string | null;
  currentVersion: number | null;
  html: string | null;
  plainText: string | null;
  links: string[];
  createdAt: string;
  updatedAt: string;
};

/** A list row — deliberately has no `html`/`links`; the API never sends a body here. */
export type TemplateListItem = {
  itemId: string;
  name: string;
  description: string | null;
  category: TemplateCategory | null;
  thumbnailUrl: string | null;
  hasContent: boolean;
  currentVersion: number | null;
  createdAt: string;
  updatedAt: string;
};

export type TemplatesPagingResult = {
  items: TemplateListItem[];
  totalCount: number;
  pageNo: number;
  pageSize: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  /** Only set when `q`/`category` narrowed the page — "showing N of totalUnfiltered". */
  totalUnfiltered?: number;
};

export type GetTemplatesParams = {
  pageNo?: number;
  pageSize?: number;
  q?: string;
  category?: TemplateCategory;
  sort?: 'created' | 'updated' | 'name';
  order?: 'asc' | 'desc';
};

export type CreateTemplateInput = {
  name: string;
  html: string;
  description?: string;
  category?: TemplateCategory | null;
};

export type UpdateTemplateInput = {
  name?: string;
  html?: string;
  description?: string;
  category?: TemplateCategory | null;
};

export type TemplateContentVersionSummary = {
  version: number;
  contentId: string;
  isCurrent: boolean;
  linkCount: number;
  hasPlainText: boolean;
  createdAt: string;
  createdBy: string;
};

export type TemplateContentVersionDetail = TemplateContentVersionSummary & {
  html: string;
  plainText: string | null;
  links: string[];
};
